export default {
  NAVIGATION: {
    TITLE: 'wokapIA',
    SHORTS_TITLE: 'wokapIA',
    PREVIOUS_CANDIDATE: 'Candidat@ anterior',
    NEXT_CANDIDATE: 'Siguiente candidat@',
    NO_MORE_CANDIDATES: 'No hay más candidat@s que mostrar. Elimina los filtros para ver a tod@s l@s candidat@s.',
    ADD_TO_SELECTION: 'Añadir a selección',
    SELECTED: 'Seleccionad@',
    SKILLS_SECTION_TITLE: 'Aptitudes, Habilidades e Idiomas',
    HEADER_TITLE: 'Descubre a tu próxim@ candidat@',
    // \n = forced line break (rendered with white-space: pre-line)
    HEADER_SUBTITLE: 'Navega por la red de wokap y\naplica filtros para encontrar perfiles específicos.',
    NETWORK_STATUS_PROFILES: 'perfiles',
    NETWORK_STATUS_AVAILABLE: 'disponibles en este momento.',
    // Compact header badge shown only while browsing the whole network (no filters/search applied)
    NETWORK_TOTAL_AVAILABLE: 'Candidat@s disponibles',
    NO_CANDIDATES: 'No hay candidat@s que coincidan con estos filtros.',
    CANDIDATES_SELECTED: 'candidat@s seleccionad@s',
    CANDIDATE_SELECTED: 'candidat@ seleccionad@',
    REMOVE_FROM_SELECTION: 'Quitar de selección',
    CANDIDATES_FILTERED: 'candidat@s filtrad@s',
    CANDIDATE_FILTERED: 'candidat@ filtrad@',
    CLEAR_FILTERS_ARIA: 'Borrar filtros',
    CANDIDATE_SEARCH_PLACEHOLDER: 'Buscar candidat@...',
    CREATE_OFFER: 'Crear carpeta',
    CREATE_OFFER_TOOLTIP: 'Crea una oferta para invitar a estos candidatos a inscribirse a tu oferta de trabajo',
    CREATE_OFFER_TOOLTIP_EMPTY: 'Selecciona uno o más candidat@s para crear una oferta e invitarl@s a inscribirse en tu oferta.',
    CLEAR_SELECTION: 'Deseleccionar',
    NOT_ENROLLED_CV_TOOLTIP: 'Esta persona aún no se ha inscrito en la oferta. Invítal@ y, una vez que se inscriba, podrás ver su perfil completo.',
    PANEL_COLLAPSE: 'Contraer',
    PANEL_EXPAND: 'Expandir',
    INFO_PANEL_TITLE: 'Información de Candidat@',
    // Placeholder used instead of the real name in the info panel's empty-state lines
    // (e.g. "Candidat@ no ha registrado ninguna aptitud técnica.")
    EMPTY_STATE_NAME: 'Candidat@',
    // Shown by PreventDirtyFormGuard when leaving the page with candidates still selected
    EXIT_GUARD_TITLE: 'Tienes candidat@s seleccionad@s',
    EXIT_GUARD_MESSAGE: 'Si sales ahora perderás la selección. Crea una carpeta para guardarla antes de salir.',
    EXIT_GUARD_ACCEPT: 'Salir sin guardar',
    EXIT_GUARD_REJECT: 'Quedarme',
  },
};
